import { render } from "./optionbuttonmulti.vue?vue&type=template&id=94c4d31e"
import script from "./optionbuttonmulti.vue?vue&type=script&lang=js"
export * from "./optionbuttonmulti.vue?vue&type=script&lang=js"

import "./optionbuttonmulti.vue?vue&type=style&index=0&id=94c4d31e&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__